// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__2VrNJ","Container_size_s":"Container_Container_size_s__3QynB","Container_size_m":"Container_Container_size_m__2ysPt"};